import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFilter = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.167 11.667a.5.5 0 0 0-.5-.5H.833v1h3.834a.5.5 0 0 0 .5-.5ZM10.833 4.333a.5.5 0 0 1 .5-.5h3.834v1h-3.834a.5.5 0 0 1-.5-.5ZM15.166 11.667v-.5h-6.5a.5.5 0 0 0 0 1h6.5v-.5ZM.833 4.333v-.5h6.5a.5.5 0 0 1 0 1h-6.5v-.5Z",
    fill: props.color || "#58595B"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 10.1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm2.5 1.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0ZM9.333 2.767a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-2.5 1.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
    fill: props.color || "#58595B"
  })]
}));
export default SvgFilter;